import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetAppConfigListOutput } from './GetAppConfigListOutput';

export class GetAppConfigListService extends HttpServiceBase {

  handle = (): Promise<Result<GetAppConfigListOutput> | null> => {
    const promise = this.http.get<Result<GetAppConfigListOutput>>(`${this.baseUrlSislogApi}/v2/app-config/list-all`);
    return promise;
  }
}